import axios from './configAxios';

export const postVehicleApi = async (formData) => {
	return await axios.post(`/vehicle/create/`, formData);
};
